<script lang="ts">
	//Helpers
	import { get_local_ip, real_id } from '../../../../../helpers/interface_helpers';
	import { formatSnakeCaseToTitle } from '../../../../../helpers/utilities';
	//Services
	import { localReq, postReq } from '../../../../../services/http';
	import { format } from '../../../../../services/i18n';
	//Stores
	import {
		getDeviceStatus,
		getDeviceSettings,
		readDeviceSettings,
	} from 'src/stores/device-runtime/status-selectors';
	import { devices_settings } from 'src/stores/device-runtime/status';
	//Design system components
	import { Button, Checkbox, Radio, toast } from '@Shelly/shelly-design-system';

	export let device;

	const id = real_id(device.id);

	let settings = readDeviceSettings(id);
	$: settingsStore = getDeviceSettings(id);
	$: settings = $settingsStore ?? settings;

	const btnTypes = ['toggle', 'momentary'];
	const options = [
		$format('option_toggle_switch_by_category', {
			values: { device_category: $format('this_inputs_reader') },
			default:
				'Toggle Switch - Set Shelly device to be "Toggle" switch. Act as a flip switch with one state for "ON" and one state for "OFF".',
		}),
		$format('option_momentary', {
			default:
				'Momentary - Set Shelly device to be "Momentary" switch. Push-for "ON" or Push-for "OFF".',
		}),
	];

	let reverse = settings.inputs[device.channel].btn_reverse;
	let cacheReverse = reverse;

	let index = btnTypes.indexOf(settings.inputs[device.channel].btn_type);
	let cacheIndex = index;
	let loading = false;
	let localIp = get_local_ip(id);

	const toggleReverse = () => {
		reverse = !reverse;
	};

	const setType = (val) => {
		index = val;
	};

	const sentRequests = async () => {
		let setBtnType; //prepare variable for first promise
		let handleToggle; //prepare variable for second promise
		if (cacheIndex !== index) {
			loading = true;
			if (localIp) {
				setBtnType = await localReq(
					device,
					`${localIp}/settings/input/${device.channel}`,
					'post',
					{
						btn_type: btnTypes[index],
					},
				);
			} else {
				setBtnType = await postReq(`/device/${device.category}/button_type`, {
					id: id,
					channel: device.channel,
					type: btnTypes[index],
				});
			}
		}
		if (cacheReverse !== reverse) {
			loading = true;
			if (localIp) {
				handleToggle = await localReq(
					device,
					`${localIp}/settings/input/${device.channel}`,
					'post',
					{
						btn_reverse: reverse,
					},
				);
			} else {
				handleToggle = await postReq(`/device/${device.category}/settings/reverse_toggle`, {
					id: id,
					channel: device.channel,
					type: reverse ? 1 : 0,
				});
			}
		}
		Promise.all([setBtnType, handleToggle]).then((res) => {
			//here based on changed settings we will have two or less requests. If no setting changed array's member will be undefined
			if (typeof res[0] !== 'undefined') {
				if (res[0].isok) {
					settings.inputs[device.channel].btn_type = btnTypes[index];
					devices_settings.update_devices_settings(id, settings);
					toast.open({
						type: 'success',
						title:
							$format('btn_type_scc_toast', {
								values: { type_value: formatSnakeCaseToTitle(btnTypes[index]) },
							}) ||
							`Button type was changed to ${formatSnakeCaseToTitle(btnTypes[index])}.`,
					});
					cacheIndex = index;
				} else {
					toast.open({ type: 'danger', title: $format('error_global') });
					index = cacheIndex;
				}
			}
			if (typeof res[1] !== 'undefined') {
				if (res[1].isok) {
					settings.inputs[device.channel].btn_reverse = reverse;
					devices_settings.update_devices_settings(id, settings);
					toast.open({
						type: 'success',
						title: $format('swap_inputs_scc_toast') || `Inputs was swapped.`,
					});
					cacheReverse = reverse;
				} else {
					toast.open({ type: 'danger', title: $format('error_global') });
					reverse = cacheReverse;
				}
			}
			loading = false;
		});
	};
</script>

{#each btnTypes as _type, i}
	<Radio
		size="m"
		selected={index.toString()}
		value={i.toString()}
		on:click={() => setType(i)}
		id="radio-t7a01os">{options[i]}</Radio
	>
{/each}

<Checkbox size="m" checked={reverse} on:click={toggleReverse} id="checkbox-i3o8r33"
	>{$format('option_reverse_inputs') ||
		'Swap inputs - If you enable this option, the buttons On/Off position will be inverted.'}</Checkbox
>
<Button class="mt-s" {loading} size="m" width="full" on:click={sentRequests}
	>{$format('button_save')}</Button
>
